import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RavIcon, RavIconOutlined } from '@shared/icon/icon';
import { ScopeService } from '@shared/services/scope.service';
import { TableAction, TableActions } from '../actions/action';

/**
 * Displays and triggers actions with a name and icon for interacting with selected items.
 */
@Component({
  selector: 'rav-mobile-actions',
  templateUrl: './mobile-actions.component.html',
  styleUrls: ['./mobile-actions.component.scss']
})
export class MobileActionsComponent {
  @Input() totalItems: number;
  @Input() actions: TableAction[];
  @Input() selectedItems: any[];
  @Output() actionTriggered = new EventEmitter<string>();
  @Output() cancelClick = new EventEmitter();
  RavIcon = RavIcon;
  RavIconOutlined = RavIconOutlined;
  TableActions = TableActions;

  constructor(public scope: ScopeService) {}

  /**
   * Determines whether to show the action
   */
  showAction(action: TableAction): boolean {
    return !(action.name === 'Create New' || action.name === 'Add New');
  }

  /**
   * Validates action triggered is enabled and emits actionTriggered.
   *
   * @param action clicked table action
   */
  onActionIconClick(action: TableAction): void {
    if (
      !this.scope.hasAccesses(action.scope) ||
      !this.showAction(action) ||
      !TableActions.isEnabled(action, this.selectedItems) ||
      action.disabled
    ) {
      return;
    }
    this.actionTriggered.next(action.name);
  }
}
